export interface UserSession {
    sessionStartTime?: number;
    lastPingTime: number,
    activeTour: string,
    lastUnlock: number,
    unlockedStories: number,
    email: string,
    deviceKey: string,
    roundTripTime: number,
    userKey: string,
    userAgent: string,
    city: string,
    version: string,
}
